import { useSubscription } from "./useSubscription";
import { expandPlanFeatures } from "@/lib/planCatalog";

/**
 * Feature-gate hook. Returns `true` if the current workspace's active plan
 * includes the given feature key in its `features` array.
 *
 * Loading state returns `undefined` so callers can distinguish "not yet known"
 * from "explicitly denied". Expired/frozen subscriptions are handled elsewhere
 * (SubscriptionGuard); this hook only reports plan capability.
 */
export const usePlanFeature = (feature: string): boolean | undefined => {
  const { data, isLoading } = useSubscription();
  if (isLoading) return undefined;
  return expandPlanFeatures(data?.plan?.features).has(feature);
};
